export const GET_COURSES = 'course/getCourses';
export const GET_COURSES_SUCCESS = 'course/getCoursesSuccess';
export const GET_COURSES_ERROR = 'course/getCoursesError';
export const GET_COURSES_NETWORK_ERROR = 'course/getCoursesNetworkError';

export const GET_MORE_COURSES = 'course/getMoreCourses';
export const GET_MORE_COURSES_SUCCESS = 'course/getMoreCoursesSuccess';

export const GET_COURSE_DETAILS = 'course/getCourseDetails';
export const GET_COURSE_DETAILS_SUCCESS = 'course/getCourseDetailsSuccess';
export const GET_COURSE_DETAILS_ERROR = 'course/getCourseDetailsError';
export const GET_COURSE_DETAILS_NETWORK_ERROR = 'course/getCourseDetailsError';

export const RESET_COURSES = 'course/resetCourses';
